import { postMessageToMiniApp } from "@/lib/post-message";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

interface NewsCardProps {
	title: string;
	description?: string;
	url: string;
}

const NewsCard = ({ title, description, url }: NewsCardProps) => {
	const handleClick = () => {
		postMessageToMiniApp({ type: "open-symphonics-blog", url });
		window.open(url, "_blank", "noopener,noreferrer");
	};

	return (
		<Card className="rounded-3xl shadow-sm overflow-hidden bg-white">
			<CardContent className="p-6">
				<div className="space-y-3">
					<h3 className="text-xl font-bold text-gray-900">{title}</h3>
					<p className="text-gray-600 text-base leading-relaxed">
						{description}
					</p>
				</div>
				<div className="mt-6 flex justify-end">
					<Button
						className="bg-[#E6007E] hover:bg-[#C5006D] transition-colors rounded-full px-6"
						onClick={handleClick}
					>
						<span className="mr-2 text-sm font-medium">En savoir plus</span>
						<ArrowRight className="h-4 w-4" />
					</Button>
				</div>
			</CardContent>
		</Card>
	);
};

export default NewsCard;
